<template>
	<Popover
		top
		:offsetY="-10"
		:open="show"
		@open="show = true"
		@close="onClose"
		ref="popover"
	>
		<slot />
		<template #content>
			<Giphy
				v-if="show"
				@click="onClick"
				@close="onClose"
				aria-label="select gif"
			/>
		</template>
	</Popover>
</template>

<script>
import Popover from './Popover.vue'
import Giphy from '../Giphy'

export default {
	name: 'GiphyPicker',
	components: { Giphy, Popover },
	data() {
		return { show: false }
	},
	emits: ['showGiphy', 'change'],
	watch: {
		show(show) {
			EventBus.$emit('showGiphy', show)
		},
	},
	methods: {
		onClick(gif) {
			this.$emit('change', gif)
			this.onClose()
		},
		onClose() {
			this.show = false
		},
		showGiphy() {
			this.show = true
		},
	},
}
</script>
